export default __webpack_public_path__ + "static/media/OurCompany.98a0ae19.png";